// extracted by mini-css-extract-plugin
export default {"switcher_container":"index_switcher_container__i3BBh","switcher_container1":"index_switcher_container1__JP4-A"};